// MB-I18N-1 — Source unique de vérité pour les locales du SOFTWARE (App Client / POS / OS / Admin).
// N'affecte PAS le marketing (piloté par lib/marketingLocale.js).

export const DEFAULT_LOCALE = 'fr';

// Langues officiellement activées côté software (sélecteur, langue active).
export const ENABLED_LOCALES = ['fr', 'en'];

// Langues à rendu droite-à-gauche (préparation future ; aucune activée dans ce batch).
export const RTL_LOCALES = ['ar'];

// Langues historiques désactivées : toute valeur persistée est ramenée à DEFAULT_LOCALE.
export const LEGACY_DISABLED_LOCALES = ['ar'];

export const isLocaleEnabled = (locale) => ENABLED_LOCALES.includes(locale);

export const isRtlLocale = (locale) => RTL_LOCALES.includes(locale);
